/**
 * Express Checkout Element payment-method visibility for the instalments surfaces.
 *
 * Why this exists (owner decision 2026-09-06, US/mobile): Stripe renders Klarna
 * as a BUTTON in the Express Checkout row (top row: Klarna, Amazon Pay, Link)
 * and a method shown there is DEMOTED out of the Payment Element tabs, and the tabs
 * then read Card, Afterpay, Bank with Klarna hidden in the "+ more" overflow.
 * The tabs are where the instalments messaging lives ("as low as $X / month"),
 * so Klarna belongs next to Card and Afterpay there, not in the express row.
 * Turning Klarna off in the express row is what puts it back in the tabs.
 *
 * Scope: Klarna only. Apple Pay / Google Pay / Link / Amazon Pay in the express
 * row are untouched (no key for them → Stripe's own defaults keep applying).
 *
 * Display/UI only; it touches no amount and no currency.
 */
import type { ExpressCheckoutPaymentMethodsOption } from "@stripe/stripe-js";

/**
 * The `paymentMethods` to pass to the Express Checkout Element, or `undefined`
 * when the key must be omitted entirely.
 *
 * With `installmentsEnabled` false the caller spreads `undefined` into the
 * options object, which is byte-for-byte the options the surface had before
 * instalments existed.
 */
export function expressCheckoutPaymentMethodsFor(
  installmentsEnabled: boolean,
): ExpressCheckoutPaymentMethodsOption | undefined {
  if (!installmentsEnabled) return undefined;
  return { klarna: "never" };
}
